import { render, staticRenderFns } from "./TheForm.vue?vue&type=template&id=588b757a&scoped=true"
import script from "./TheForm.vue?vue&type=script&lang=js"
export * from "./TheForm.vue?vue&type=script&lang=js"
import style0 from "./TheForm.vue?vue&type=style&index=0&id=588b757a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b757a",
  null
  
)

export default component.exports